import React, { useEffect } from "react";
import { Backdrop } from "../backdrop/backdrop";
import AudioPlayer from "./AudioPlayer";
import VideoPlayer from "./VideoPlayer";
import { SwitchTransition, Transition } from "react-transition-group";

import {
  useToggleMediaPlayer,
  useSetCourseMedia,
  useSetCurrentTrack,
  useStoreContext,
} from "src/context/siteContext";

import cx from "classnames";

const TRANSITION_DURATION = 200;

const AUDIO_TRANSITION_STYLES = {
  default: {
    transform: "translateY(100%)",
  },
  entering: {
    transform: "translateY(100%)",
  },
  entered: {
    transform: "translateY(0)",
  },
  exiting: {
    transform: "translateY(100%)",
  },
  exited: {
    transform: "translateY(100%)",
  },
};

const VIDEO_TRANSITION_STYLES = {
  default: {
    transition: `opacity ${TRANSITION_DURATION}ms ease`,
  },
  entering: {
    opacity: 0,
  },
  entered: {
    opacity: 1,
  },
  exiting: {
    opacity: 0,
  },
  exited: {
    opacity: 0,
  },
};

const MediaPlayer = () => {
  const { courseMediaType } = useStoreContext();

  const setMediaPlayerOpen = useToggleMediaPlayer();
  const setCourseMedia = useSetCourseMedia();
  const setCurrentTrack = useSetCurrentTrack();

  useEffect(() => {
    return () => {
      setMediaPlayerOpen(false);
      setCourseMedia(undefined);
      setCurrentTrack([]);
    };
  }, []);

  return (
    <SwitchTransition>
      <Transition
        key={courseMediaType}
        mountOnEnter
        unmountOnExit
        appear
        timeout={TRANSITION_DURATION}
      >
        {(status) => (
          <React.Fragment>
            {courseMediaType === "audio" && (
              <React.Fragment>
                <Backdrop
                  toggle={() => {
                    setMediaPlayerOpen(false);
                    setCourseMedia(undefined);
                    setCurrentTrack([]);
                  }}
                  course
                  active
                />
                <section
                  className="media-player fix bottom left right"
                  style={{
                    ...AUDIO_TRANSITION_STYLES.default,
                    ...AUDIO_TRANSITION_STYLES[status],
                  }}
                >
                  <AudioPlayer />
                </section>
              </React.Fragment>
            )}

            {courseMediaType === "video" && (
              <section
                className="media-player media-player--video fix bottom left top right"
                style={{
                  ...VIDEO_TRANSITION_STYLES.default,
                  ...VIDEO_TRANSITION_STYLES[status],
                }}
              >
                <VideoPlayer />
              </section>
            )}
          </React.Fragment>
        )}
      </Transition>
    </SwitchTransition>
  );
};

export default MediaPlayer;
